export default __webpack_public_path__ + "static/media/jihyo.7e9c6f77.jpg";